import { useState } from "react";
import { InlineHelp } from "@/components/common/InlineHelp";
import { parseIdeaRoomExportJson, translateIdeaRoomExport } from "@/lib/ops/ideaRoomExport";
import { importIdeaRoomOrderIntake } from "@/lib/orderIntakeClient";

const inputClass = "mt-1 block w-full rounded border border-gray-300 px-2 py-1 text-sm font-mono";

export function OpsIdeaRoomImportSection(props: { setMsg: (s: string) => void }) {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [formError, setFormError] = useState<string | null>(null);

  const preview = (() => {
    const parsed = parseIdeaRoomExportJson(text);
    if (!parsed.ok) return null;
    const t = translateIdeaRoomExport(parsed.payload);
    return t.ok ? t.translation : null;
  })();

  async function submit() {
    setFormError(null);
    const parsed = parseIdeaRoomExportJson(text);
    if (!parsed.ok) {
      setFormError(parsed.error);
      return;
    }
    const t = translateIdeaRoomExport(parsed.payload);
    if (!t.ok) {
      setFormError(t.error);
      return;
    }
    setBusy(true);
    const r = await importIdeaRoomOrderIntake(parsed.payload);
    setBusy(false);
    if (!r.ok) {
      setFormError(r.error);
      return;
    }
    setText("");
    props.setMsg(
      "IdeaRoom order landed in Pending Review. Accept it from Manufacturing → Order Intake to open the deal."
    );
  }

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <p className="text-xs font-medium text-gray-600">IdeaRoom</p>
        <InlineHelp label="How IdeaRoom import works">
          Paste an IdeaRoom export so it becomes an Order Intake row. The webhook URL is under Inbound
          webhooks (same org token). Same order id merges into an existing on-hold row.
        </InlineHelp>
      </div>
      <textarea
        className={`${inputClass} min-h-[8rem] text-xs`}
        value={text}
        disabled={busy}
        onChange={(e) => setText(e.target.value)}
        placeholder='{"eventType":"created","hash":"…","order":{"customer":{"firstName":"…"}}}'
      />
      {preview ? (
        <p className="text-xs text-gray-600">
          Will import <span className="font-medium">{preview.external_source_id}</span>
          {preview.customer_display_name ? ` · ${preview.customer_display_name}` : ""} · {preview.kind}
        </p>
      ) : null}
      {formError ? <p className="text-sm text-amber-800">{formError}</p> : null}
      <button
        type="button"
        className="rounded border px-3 py-1 text-sm disabled:opacity-50"
        disabled={busy || !text.trim()}
        onClick={() => void submit()}
      >
        {busy ? "Importing…" : "Import to review queue"}
      </button>
    </div>
  );
}
